import { useAuth } from "@/contexts/AuthContext";
import { useModuleVisibility } from "@/lib/moduleVisibility";

/**
 * Renders `children` only when the signed-in viewer's org has `module` switched
 * on. Signed-out visitors always see the children: the visibility endpoint needs
 * a session, so the hook is only mounted once there is a user (a hook can't sit
 * behind a conditional, a child component can).
 */
export default function IfModuleVisible({ module, children }: { module?: string; children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user || !module) return <>{children}</>;
  return <Gate module={module}>{children}</Gate>;
}

function Gate({ module, children }: { module: string; children: React.ReactNode }) {
  const isModuleVisible = useModuleVisibility();
  return isModuleVisible(module) ? <>{children}</> : null;
}
